import { useCallback, useState } from 'react';

export type ToastSeverity = 'success' | 'error';

export interface Toast {
  key: number;
  message: string;
  severity: ToastSeverity;
}

export function useToast() {
  const [toast, setToast] = useState<Toast | null>(null);
  const notify = useCallback(
    (message: string, severity: ToastSeverity = 'success') => setToast({ key: Date.now(), message, severity }),
    [],
  );
  const dismiss = useCallback(() => setToast(null), []);
  return { toast, notify, dismiss };
}
